export default __webpack_public_path__ + "static/media/messageSent.bd87c5f8.jpg";